/* Built In Imports */
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';

/* External Imports */
import { Box, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/* Mixpanel for SEO*/
import { mixPanel } from '@utils/Mixpanel';
/* Services */

/**
 *
 * @param {Object} headTopMenuData
 * @returns
 */
const NotLoggedIn = ({ type, headTopMenuData, page }) => {
  // const loggedinMenu = headTopMenuData[7]?.submenuItems;
  const router = useRouter();
  const [pageTitle, setPageTitle] = useState();

  const loginURL = `${config.FACADE_BASE_PATH}/login?request_url=${config.BASE_PATH}${router.asPath}&action=0`;
  const signupURL = `${config.FACADE_BASE_PATH}/login?request_url=${config.BASE_PATH}${router.asPath}&action=1`;

  useEffect(() => {
    setPageTitle(window.document.title);
  }, []);

  const mixpanelTrigger = (eventKey, button_name, page_url) => {
    const Mixpanel = mixPanel(router.asPath);
    Mixpanel.track(eventKey, {
      page_name: pageTitle,
      page_url: page_url,
      button_name: button_name,
    });
  };

  return (
    <>
      {type == 'mobile' ? (
        <Box float="left" mt={{base:'14px', md:'25px'}} ml="20px">
          <Link
            onClick={() =>
              mixpanelTrigger('iso_login_sign_up_click', 'login', router.asPath)
            }
            href={loginURL}
            float="left"
            fontSize="14"
            color={page === 'Samskriti' ? '#ffffff' : '#464038'}
            fontFamily="FedraSansStd-medium,sans-serif"
            textDecoration="none"
            mr="8px"
            id={headTopMenuData[6]?.title}
          >
            {headTopMenuData[6]?.title}
          </Link>
          <Box
            as="span"
            color="#464038"
            float="left"
            position={'relative'}
            top="-2px"
          >
            |
          </Box>
          <Link
            onclick={() =>
              mixpanelTrigger(
                'iso_login_sign_up_click',
                'signup',
                router.asPath
              )
            }
            href={signupURL}
            float="left"
            fontSize="14"
            color={page === 'Samskriti' ? '#ffffff' : '#464038'}
            fontFamily="FedraSansStd-medium,sans-serif"
            textDecoration="none"
            ml="8px"
            pos="relative"
            id={headTopMenuData[7]?.title}
          >
            {headTopMenuData[7]?.title}
          </Link>
        </Box>
      ) : (
        <Box mt="11px" pos="relative">
          <Link
            onClick={() =>
              mixpanelTrigger('iso_login_sign_up_click', 'login', router.asPath)
            }
            href={loginURL}
            float="left"
            width="auto"
            fontSize="12"
            color={page === 'Samskriti' ? '#ffffff' : '#464038'}
            fontFamily="FedraSansStd-medium,sans-serif"
            _hover={{ color: '#cf4824' }}
            pr="2px"
            id={headTopMenuData[6]?.title}
          >
            {headTopMenuData[6]?.title}
          </Link>
          <Text
            as="span"
            float="left"
            width="auto"
            fontSize="12"
            color={page === 'Samskriti' ? '#ffffff' : '#464038'}
            m="0 1px 0 0"
            fontWeight="bold"
            lineHeight="inherit"
          >
            &nbsp;|&nbsp;
          </Text>
          <Link
            onclick={() =>
              mixpanelTrigger(
                'iso_login_sign_up_click',
                'signup',
                router.asPath
              )
            }
            href={signupURL}
            float="left"
            width="auto"
            fontSize="12"
            color={page === 'Samskriti' ? '#ffffff' : '#464038'}
            fontFamily="FedraSansStd-medium,sans-serif"
            _hover={{ color: '#cf4824' }}
            pl="2px"
            id={headTopMenuData[7]?.title}
          >
            {headTopMenuData[7]?.title}
          </Link>
        </Box>
      )}
    </>
  );
};

export default NotLoggedIn;
